// extracted by mini-css-extract-plugin
export default {"IconButton_SVG":"IconButton_SVG_mRAm2_v17-8-1"};